const prefix = process.env.NODE_ENV === 'development' ? 'bank-authentication' : 'bank-authentication';

export const bank_two_factor_generate = `${prefix}/2fa/generate`;
export const bank_post_enable_two_factor = `${prefix}/2fa/enable`;
export const bank_change_password = `${prefix}/user/change/password`;
